/**
 * useNewslettersAdmin — encapsulates newsletter list state and load handler
 * for AdminDashboard. Extracted as part of P3-3 refactor.
 */
import { useState, useCallback } from "react";
import axios from "axios";
import { toast } from "sonner";
import { BACKEND_URL } from "../lib/backend";

const API = `${BACKEND_URL}/api`;

export function useNewslettersAdmin(authHeader) {
  const [newsletters, setNewsletters] = useState([]);
  const [loadingNL, setLoadingNL] = useState(false);
  const [expandedNL, setExpandedNL] = useState(null);

  // Featured-for-newsletter list (persistent, editable — mirror of brief featured + podcast queue)
  const [nlFeatured, setNlFeatured] = useState([]);
  const [loadingNlFeatured, setLoadingNlFeatured] = useState(false);

  const loadNewsletters = useCallback(async () => {
    setLoadingNL(true);
    try {
      const res = await axios.get(`${API}/admin/newsletters`, { headers: authHeader() });
      setNewsletters(res.data.newsletters || []);
    } catch { toast.error("Failed to load newsletters"); }
    finally { setLoadingNL(false); }
  }, [authHeader]);

  const loadNlFeatured = useCallback(async () => {
    setLoadingNlFeatured(true);
    try {
      const res = await axios.get(`${API}/admin/newsletter/featured`, { headers: authHeader() });
      setNlFeatured(res.data.articles || []);
    } catch { /* silent */ }
    finally { setLoadingNlFeatured(false); }
  }, [authHeader]);

  const removeNlFeatured = async (articleId) => {
    try {
      await axios.delete(`${API}/admin/newsletter/featured/${encodeURIComponent(articleId)}`, { headers: authHeader() });
      setNlFeatured(prev => prev.filter(a => (a.id || a.originalUrl) !== articleId));
      toast.success("Article removed from newsletter queue");
    } catch (e) { toast.error(e.response?.data?.detail || "Remove failed"); }
  };

  const clearNlFeatured = async () => {
    try {
      await axios.delete(`${API}/admin/newsletter/featured`, { headers: authHeader() });
      setNlFeatured([]);
      toast.success("Newsletter queue cleared");
    } catch { toast.error("Clear failed"); }
  };

  return {
    newsletters, loadingNL, expandedNL, setExpandedNL, loadNewsletters,
    nlFeatured, loadingNlFeatured, loadNlFeatured, removeNlFeatured, clearNlFeatured,
  };
}
